<template>
  <bim-popup
    v-if="locationPopupVisibility"
    v-model="locationPopupVisibility"
    class="location-popup"
    title="Помогите сервису работать лучше, укажите ваше местоположение"
  >
    <div v-if="!selectMode">
      <p>Ваш регион: {{regionFromFetchByLatLon}}?</p>
      <br />
      <div class="location-popup__actions">
        <bim-button label="Нет" @click="confirmLocation(false)" />
        <bim-button label="Да" @click="confirmLocation(true)" />
      </div>
    </div>
    <div v-else>
      <bim-select
        class="select-location"
        placeholder="Выберите страну"
        :options="locationOptions"
        width="100%"
        valueName="id"
        labelName="name"
        v-model="selectedCountryId"
      />
      <br />
      <div class="location-popup__regions" v-if="selectedCountryId">
        <div class="checkbox-tree" v-if="selectedLocationObject.regions_list.length">
          <bim-radio
            class="d-flex mb-6"
            v-model="selectedRegionId"
            v-for="el in selectedLocationObject.regions_list"
            :key="el.id"
            name="region"
            :val="el.id"
            :label="el.name"
          />
        </div>
        <div v-else>У выбранной страны регионы пока не поддерживаются.</div>
      </div>
      <br />
      <div class="location-popup__actions">
        <bim-button @click="changeLocation(false)">Отмена</bim-button>
        <bim-button @click="changeLocation(true)" :disabled="!selectedRegionId">Подтвердить</bim-button>
      </div>
    </div>
  </bim-popup>
</template>

<script>
// если не задано местоположение - необходимо задать
import bimPopup from '@bimlib/components/bimPopup'
import bimButton from '@bimlib/components/bimButton'
import bimRadio from '@bimlib/components/bimRadio'
import bimSelect from '@bimlib/components/bimSelect'

export default {
  name: 'LocationPopup',
  components: {
    bimPopup,
    bimButton,
    bimRadio,
    bimSelect
  },
  data () {
    return {
      locationPopupVisibility: false, // popup state
      latitude: '',
      longitude: '',
      selectedCountryId: null,   // Страна которую пользователь выбрал сам принудительно
      selectedRegionId: null,   // Регион которую пользователь выбрал сам принудительно
      locationOptions: [],
      selectMode: false,
      twoDaysInMs: 86400000,     // два дня в миллисекундах
    }
  },
  computed: {
    selectedLocationObject(){
      return this.locationOptions.find(itm => itm.id === this.selectedCountryId)
    },
  },
  methods: {
    async showLocationPopup(){
      await axios
      .get(`/web-api-2/geo/get_geo_list`)
        .then((getResult) => {
          this.locationOptions = getResult.data.data
          return getResult.data.data
        })
        .catch(()=>{})
      await axios
      .get(`/web-api-2/geo/search_by_coordinates_osm/${this.latitude}/${this.longitude}`)
        .then((getResult) => {
          this.regionFromFetchByLatLon = getResult.data.data.address.state
          this.locationPopupVisibility = true
          return getResult.data.data.address.state
        })
        .catch(()=>{})
    },
    async checkGeolocation () {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              this.latitude = position.coords.latitude
              this.longitude = position.coords.longitude
              await axios
              .get(`/web-api-2/geo`, { params: {lat: this.latitude, lon: this.longitude}})
                .then((getResult) => {
                  if(!getResult.data.data.isCorrect){
                    const dateFromLS = localStorage.getItem('location_popup_closed_at')
                    const dateDifference = new Date() - new Date(dateFromLS)
                    if(dateFromLS){
                      if(dateDifference > this.twoDaysInMs){
                        // прошло ли больше 2-х дней с момента первого закрытия модалки
                        this.showLocationPopup()
                      }
                    } else {
                      this.showLocationPopup()
                    }
                  }
                  return getResult.data.data
                })
                .catch(()=>{})
            },
            (error) => {
              axios.get(`/web-api-2/geo`)
              console.error('Ошибка при получении геолокации:', error)
            }
          )
        } else {
          console.error('Геолокация не поддерживается в вашем браузере.')
        }
    },

    async confirmLocation (confirm) {
      if (confirm) {
        await axios
          .post(`/web-api-2/geo/update_user_region`, {
            lat: this.latitude, lon: this.longitude
          })
        this.locationPopupVisibility = false
      } else {
        this.selectMode = true
      }
    },
    async changeLocation (bool) {
      if(bool){
        await axios
          .post(`/web-api-2/geo/update_user_region`, {
            region_id: this.selectedRegionId
          })
        this.locationPopupVisibility = false
      } else {
        this.selectedCountryId = null
        this.selectedRegionId = null
        this.selectMode = false
      }
    },
  },
  async mounted () {
    const checkUserGeo = localStorage.getItem('location_none') // проверять ли у юзера гео?
    // если есть в localStorage запись - не проверять
    if(!checkUserGeo)
      this.checkGeolocation()
  },
  watch: {
    locationPopupVisibility( newValue, oldValue) {
      if(!newValue && oldValue){
        const dateFromLS = localStorage.getItem('location_popup_closed_at')
        let dateDifference = null
        if(dateFromLS){
          // когда юзер закрыл окно в 2 раз (есть дата в ls)
          dateDifference = new Date() - new Date(dateFromLS)
          if(dateDifference > this.twoDaysInMs){
            // прошло ли больше 2-х дней с момента первого закрытия модалки
            localStorage.removeItem('location_popup_closed_at')
            localStorage.setItem('location_none', 'true')
            axios.get(`/web-api-2/geo`)
          }
        } else {
          // когда юзер закрыл окно в 1 раз
          localStorage.setItem('location_popup_closed_at', new Date().toDateString())
        }
        
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.location-popup{
  &__actions{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__regions{
    border-radius: 5px;
    border-color: #4d4d4d;
  }
  .checkbox-tree{
    height: 30vh;
    overflow: hidden;
    overflow-y: auto;
  }
}
::v-deep .modal-content{
  overflow: visible;
}
::v-deep .modal-body{
  overflow-y: visible;
}
::v-deep .options__items{
  z-index: 999999999999999;
}
</style>
